import "./App.css";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";

import ReplayIcon from "@mui/icons-material/Replay";
import IconButton from "@mui/material/IconButton";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";

import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { atomDark } from "react-syntax-highlighter/dist/esm/styles/prism";

import React from "react";

class Option {
  constructor(name, type) {
    this.name = name;
    this.type = type;
  }
}

const names = require("./names.json");
const surnames = require("./surnames.json");

function randomString(length, characters) {
  let result = "";
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result;
}

/* todo:
float
bool
cont float
const int
const string */

function App() {
  const [options, setOptions] = React.useState([]);
  const [size, setSize] = React.useState(3);
  const [outputFormat, setOutputFormat] = React.useState("json");

  const generate = () => {
    let obj = [];

    for (let i = 0; i < size; i++) {
      obj[i] = {};

      for (const opt of options) {
        switch (opt.type) {
          case "integer":
            obj[i][opt.name] =
              Math.floor(Math.random() * (2147483647 + 2147483647 + 1)) -
              2147483647;
            break;
          case "integerminmax":
            obj[i][opt.name] =
              Math.floor(Math.random() * (opt.max - opt.min + 1)) + opt.min;
            break;
          case "string":
            obj[i][opt.name] = randomString(
              opt.length ?? 10,
              "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789"
            );
            break;
          case "stringdigits":
            obj[i][opt.name] = randomString(opt.length ?? 10, "0123456789");
            break;
          case "stringupperletters":
            obj[i][opt.name] = randomString(
              opt.length ?? 10,
              "ABCDEFGHIJKLMNOPQRSTUVWXYZ"
            );
            break;
          case "stringlowerletters":
            obj[i][opt.name] = randomString(
              opt.length ?? 10,
              "abcdefghijklmnopqrstuvwxyz"
            );
            break;
          case "name":
            obj[i][opt.name] =
              names[Math.floor(Math.random() * (names.length + 1))];
            break;
          case "surname":
            obj[i][opt.name] =
              surnames[Math.floor(Math.random() * (surnames.length + 1))];
            break;
        }
      }
    }

    /* return { obj, options }; */
    if(outputFormat === "json") {
      return JSON.stringify(obj, null, 4);
    } else if(outputFormat === "sql-insert") {
      let final = "INSERT INTO ?table? VALUES "+ obj.map((e) => {
        return "("+Object.keys(e).map((k) => typeof e[k] == 'number' ? `${e[k]}` : `"${e[k]}"`).join(', ')+")"
      }).join(',\n') + ";";
      console.log(final)
      return final;
    }

    return obj;
  };

  const preview = () => {
    const generated = generate();

    if(outputFormat === "json") {
      return JSON.stringify(JSON.parse(generated)[0], null, 4);
    } else if(outputFormat === "sql-insert") {
      return generated.split('\n')[0] + " ...";
    }
  }

  return (
    <div>
      <Typography variant="h3" align="center" marginTop={10}>
        Random Dummy Generator
      </Typography>

      <Box
        sx={{
          margin: "0 auto",
          width: "100%",
          maxWidth: 800,
        }}
      >
        <Box marginY={4} maxWidth="max-content" marginX="auto">
          <FormControl size="small">
            <InputLabel id="output-type-label">
              Output format
            </InputLabel>
            <Select
              labelId="output-type-label"
              id="output-type-label"
              value={outputFormat}
              sx={{ width: "20ch"}}
              label="Output format"
              onChange={(e) => {
                setOutputFormat(e.target.value);
              }}
            >
              <MenuItem value={"json"}>JSON</MenuItem>
              <MenuItem value={"sql-insert"}>SQL INSERT</MenuItem>
            </Select>
          </FormControl>
          <TextField
            label="Size"
            defaultValue={3}
            sx={{ width: "10ch",marginLeft: "15px"  }}
            size="small"
            onChange={(e) => {
              setSize(parseInt(e.target.value) || 1);
            }}
          />
          <Button
            size="large"
            color="primary"
            sx={{ marginLeft: "15px" }}
            href={
              "data:application/"+(outputFormat === 'json' ? 'json':'sql')+";charset=utf-8," +
              encodeURIComponent(generate())
            }
            download
          >
            DOWNLOAD
          </Button>
        </Box>

        <Box marginY={4}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography>Preview:</Typography>
            <IconButton
              onClick={() => {
                let temp_options = [...options];
                setOptions(temp_options);
              }}
            >
              <ReplayIcon />
            </IconButton>
          </Box>
          <SyntaxHighlighter language={outputFormat === 'json' ? 'json':'sql'} style={atomDark}>
            {preview()}
          </SyntaxHighlighter>
        </Box>

        <List>
          {options.map((opt, index) => (
            <ListItem key={index}>
              <Grid container spacing={2}>
                <Grid item xs={opt.type == "integerminmax" ? 5 : 6}>
                  <TextField
                    onChange={(e) => {
                      let temp_options = [...options];

                      temp_options[index].name = e.target.value;

                      setOptions(temp_options);
                    }}
                    label="Property name"
                    size="small"
                    fullWidth
                  />
                </Grid>
                <Grid
                  item
                  xs={
                    opt.type == "integerminmax"
                      ? 2
                      : opt.type == "string" ||
                        opt.type == "stringdigits" ||
                        opt.type == "stringupperletters" ||
                        opt.type == "stringlowerletters"
                      ? 3
                      : 5
                  }
                >
                  <FormControl fullWidth size="small">
                    <InputLabel id="property-type-label">
                      Property type
                    </InputLabel>
                    <Select
                      labelId="property-type-label"
                      id="property-type-label"
                      value={opt.type}
                      label="Property type"
                      onChange={(e) => {
                        let temp_options = [...options];

                        temp_options[index].type = e.target.value;

                        setOptions(temp_options);
                      }}
                    >
                      <MenuItem value={"integer"}>Integer</MenuItem>
                      <MenuItem value={"integerminmax"}>
                        Integer Min - Max
                      </MenuItem>
                      <MenuItem value={"string"}>String (all chars)</MenuItem>
                      <MenuItem value={"stringdigits"}>
                        String (digits only)
                      </MenuItem>
                      <MenuItem value={"stringupperletters"}>
                        String (uppercase only)
                      </MenuItem>
                      <MenuItem value={"stringlowerletters"}>
                        String (lowercase only)
                      </MenuItem>
                      <MenuItem value={"name"}>Name</MenuItem>
                      <MenuItem value={"surname"}>Surname</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                {(opt.type == "string" ||
                  opt.type == "stringdigits" ||
                  opt.type == "stringupperletters" ||
                  opt.type == "stringlowerletters") && (
                  <Grid item xs={2}>
                    <TextField
                      onChange={(e) => {
                        let temp_options = [...options];

                        temp_options[index].length = parseInt(e.target.value);

                        setOptions(temp_options);
                      }}
                      label="Length"
                      defaultValue={10}
                      size="small"
                      fullWidth
                    />
                  </Grid>
                )}
                {opt.type == "integerminmax" && (
                  <>
                    <Grid item xs={2}>
                      <TextField
                        onChange={(e) => {
                          let temp_options = [...options];

                          temp_options[index].min = parseInt(e.target.value);

                          setOptions(temp_options);
                        }}
                        label="Min"
                        size="small"
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={2}>
                      <TextField
                        onChange={(e) => {
                          let temp_options = [...options];

                          temp_options[index].max = parseInt(e.target.value);

                          setOptions(temp_options);
                        }}
                        label="Max"
                        size="small"
                        fullWidth
                      />
                    </Grid>
                  </>
                )}
                <Grid item xs={1}>
                  <IconButton
                    color="error"
                    aria-label="delete"
                    onClick={() => {
                      let temp_options = [...options];

                      temp_options.splice(index, 1);

                      setOptions(temp_options);
                    }}
                  >
                    <DeleteIcon />
                  </IconButton>
                </Grid>
              </Grid>
            </ListItem>
          ))}
          <ListItem>
            <IconButton
              size="large"
              color="primary"
              sx={{ margin: "0 auto" }}
              onClick={() => {
                setOptions([...options, new Option("", "")]);
              }}
            >
              <AddIcon />
            </IconButton>
          </ListItem>
        </List>
      </Box>
    </div>
  );
}

export default App;
